import React from 'react'
//hook for checking if an el is in viewport
import useIsInViewport from 'use-is-in-viewport'

function Johns() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>
			<div className="St-johns">
			<br/>
				<h2>St. John's University</h2>
				<h5>Sept. 2015 - May. 2019</h5>
		
				<h5>Queens, New York</h5>
				<h4>Bachelors of Science, Computer Science Degree</h4>
				<p>
				Cum Laude 3.5gpa
				</p>
			</div>
		</div>
	  )
}

export default Johns